import { useQuery } from '@tanstack/react-query';

import {
  getBrokerIntegrations,
  type GetBrokerIntegrationsResponse,
} from 'wg-api-sdk';

import wgApi from '@/lib/api/wgApi';
import queryKeys from '@/queries/queryKeys';
import type { QueryOptions } from '@/types/react-query';

export default function useBrokerIntegrations(
  brokerId: string,
  options?: QueryOptions<GetBrokerIntegrationsResponse>,
) {
  return useQuery({
    queryKey: queryKeys.brokers.integrations(brokerId),
    queryFn: () =>
      getBrokerIntegrations({ path: { broker_id: brokerId } }, wgApi),
    ...options,
  });
}
